import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../loading-service.service';
import { Observable } from 'rxjs';
import { environment as ENV } from '../../environments/environment';

@Component({
  selector: 'app-loading-animation',
  standalone: true,
  imports: [CommonModule],
  template: `
    <ng-container *ngIf="loading$ | async">
      <div *ngIf="isSfj; else fallback" class="sfj-app-loader">
        <div class="sfj-ldr-content">
          <div class="sfj-ldr-dots" role="status" aria-label="Loading">
            <span class="sfj-dot d1"></span>
            <span class="sfj-dot d2"></span>
            <span class="sfj-dot d3"></span>
            <span class="sfj-dot d4"></span>
            <span class="sfj-dot d5"></span>
          </div>
          <h2 class="sfj-ldr-heading">Loading...</h2>
          <p class="sfj-ldr-sub">Setting things up for you...</p>
        </div>
        <svg class="sfj-ldr-land" viewBox="0 0 1440 150" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
          <g opacity="0.45">
            <ellipse cx="180" cy="60" rx="80" ry="25" fill="#bfdbfe"/>
            <ellipse cx="245" cy="46" rx="58" ry="19" fill="#dbeafe"/>
            <ellipse cx="1200" cy="55" rx="72" ry="23" fill="#bfdbfe"/>
            <ellipse cx="1265" cy="42" rx="54" ry="18" fill="#dbeafe"/>
          </g>
          <path d="M0,100 Q360,30 720,80 Q1080,130 1440,60 L1440,150 L0,150 Z" fill="#d1fae5" opacity="0.7"/>
          <path d="M0,115 Q300,80 600,110 Q900,140 1200,100 Q1350,85 1440,110 L1440,150 L0,150 Z" fill="#a7f3d0" opacity="0.85"/>
          <path d="M0,132 Q360,112 720,130 Q1080,147 1440,122 L1440,150 L0,150 Z" fill="#6ee7b7"/>
        </svg>
      </div>
      <ng-template #fallback>
        <div class="loading-overlay">
          <div class="spinner"></div>
        </div>
      </ng-template>
    </ng-container>
  `,
  styles: [`
    .sfj-app-loader {
      position: fixed;
      inset: 0;
      z-index: 9999;
      background: #f8fff8;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
    .sfj-ldr-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 18px;
      position: relative;
      z-index: 1;
      margin-bottom: 40px;
    }
    .sfj-ldr-dots {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .sfj-dot {
      width: 13px;
      height: 13px;
      border-radius: 50%;
      display: inline-block;
      animation: sfj-al-bounce 1.2s ease-in-out infinite;
    }
    .d1 { background: #16A34A; animation-delay: 0s; }
    .d2 { background: #35B779; animation-delay: 0.15s; }
    .d3 { background: #5BC7A1; animation-delay: 0.3s; }
    .d4 { background: #9ADBDD; animation-delay: 0.45s; }
    .d5 { background: #D5EBF5; animation-delay: 0.6s; }
    @keyframes sfj-al-bounce {
      0%, 100% { transform: scale(0.65); opacity: 0.4; }
      50% { transform: scale(1.15); opacity: 1; }
    }
    .sfj-ldr-heading {
      margin: 0;
      font-size: 1.4rem;
      font-weight: 600;
      color: #1e293b;
      letter-spacing: -0.01em;
      font-family: var(--font-heading, 'Rubik', sans-serif);
    }
    .sfj-ldr-sub {
      margin: 0;
      font-size: 0.875rem;
      color: #64748b;
      font-family: var(--font-heading, 'Rubik', sans-serif);
    }
    .sfj-ldr-land {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 150px;
      pointer-events: none;
    }
    @media (max-width: 480px) {
      .sfj-dot { width: 10px; height: 10px; }
      .sfj-ldr-heading { font-size: 1.15rem; }
    }
    @media (prefers-reduced-motion: reduce) {
      .sfj-dot { animation: none; opacity: 0.7; }
    }
    .loading-overlay {
      position: fixed;
      top: 0; left: 0;
      width: 100%; height: 100%;
      display: flex; justify-content: center; align-items: center;
      background: rgba(0,0,0,0.3);
      z-index: 9999;
    }
    .spinner {
      width: 50px; height: 50px;
      border: 5px solid #ccc;
      border-top-color: #007bff;
      border-radius: 50%;
      animation: sfj-al-spin 1s linear infinite;
    }
    @keyframes sfj-al-spin {
      to { transform: rotate(360deg); }
    }
  `]
})
export class LoadingAnimationComponent {
  loading$ :Observable<boolean>;
  constructor(private loadingService: LoadingService) {
      this.loading$ = this.loadingService.loading$;
  }

  get isSfj(): boolean {
    return ENV.projectName === 'sahyadarifarms' && sessionStorage.getItem('custselfjourney') === 'custselfjourney';
  }
}
